import { Component, ElementRef, ViewChild, ViewEncapsulation , Renderer, Output, EventEmitter, Input } from '@angular/core';
import { IonicPage,ModalController, NavController,AlertController,Platform, LoadingController } from 'ionic-angular';
import { ElectronService } from 'ngx-electron';
import { AuthService } from '../../providers/auth-service'
import { CompaniasProvider } from '../../providers/companias/companias'
import { MensajeProvider } from '../../providers/mensaje/mensaje'
import { CajaProvider } from '../../providers/caja/caja'
import { MesasProvider } from '../../providers/mesas/mesas'
import { PushProvider } from '../../providers/push/push'
import { GESTION_PEDIDOS_SALON } from "../../config/url.servicio"
import { Turnos } from '../../models/turnos/turnos.models';
import { UsuariosProvider } from '../../providers/usuarios/usuarios';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Store } from '@ngrx/store';
import { AppState } from '../../app/app.reducer';
import { UtilsProvider } from '../../providers/utils/utils';
import { Storage } from '@ionic/storage'
import  'rxjs/add/observable/interval';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/map';
import { ParametrosGeneralesRedux } from '../../providers/redux/parametrosgenerales/parametrosgenerales';
import { GestionPedidosRedux } from '../../providers/redux/gestionpedidos/gestionpedidos';
import { TurnosRedux } from '../../providers/redux/turnos/turnos';
import { ClienteSelectRedux } from '../../providers/redux/clienteselect/clienteselect';
import { UtilsRedux } from '../../providers/redux/utils/utils'
import { Estados } from '../../models/estados/estados.models';
import { trigger, state, style, transition, animate} from '@angular/animations';
import { ClientesProvider } from '../../providers/clientes/clientes';
import { ProductosProvider } from '../../providers/productos/productos';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/observable/from';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import { GestionporproductoPage } from '../gestionporproducto/gestionporproducto';
import { ReservasProvider } from '../../providers/reservas/reservas';
import { ClienteSelectPage } from '../cliente-select/cliente-select';
import { valueDisplay } from '../../models/valueDisplay.model';
import * as fromClienteSelect from '../cliente-select/state/cliente-select/cliente-select-accions'

import * as fromClienteSelectAll from '../meseromesero/state/clienteselect/clienteselect.accions'
import { SetTurnosAction, UnsetTurnosAction } from '../meseromesero/state/turnos/turnos.accions';
import { Clienteselect } from '../../models/clienteselect/clienteselect.models';
import { MeseromeseroPage } from '../meseromesero/meseromesero';

@IonicPage()
@Component({
  selector: 'page-reservas',
  templateUrl: 'reservas.html',
  encapsulation: ViewEncapsulation.None,
  providers: [ AuthService,CompaniasProvider,MensajeProvider,
    CajaProvider,MesasProvider,ElectronService,PushProvider,InAppBrowser,ParametrosGeneralesRedux,
    GestionPedidosRedux, TurnosRedux, ClienteSelectRedux, UtilsRedux,ReservasProvider,MeseromeseroPage],
    animations: [
      trigger('openClose', [
          state('collapsed, void', style({height:'0px'})),
          state('expanded', style({height:'*'})),
          transition('collapsed <=> expanded',[animate(300,style({height:'*'})),
              animate(300)])

      ])
  ]
})
export class ReservasPage {
  title;
  nombrecaja: string;
  listaMuestra = [];
  listaMuestraOcupadas = [];
  actualizar:any= [{
    valor:0
  }]
  datatitle = []
  valortitle: string = "meseros"

  listaGruposProductos = []
  listaGruposProductosMesa = []
  listaProductos = []
  listaCentroDeCostosGestion = []
  listaProductosMesa = []
  clienteGenerico
  clienteGenericoMesa

  nombreFiltroGrupo
  filtroGruposActivo: boolean = false
  listaProductosSeleccionados = []
  valorTotalVenta = 0
  valorTotalProductos = 0
  valorTotalImpuestos = 0
  price = 0
  valorTotalDevolver = 0
  datosAdicionalesArrayMesero = []
  realizandoUnaVenta: boolean = false

  numeromesa
  numeromesaMostrar: any = ""

  clienteId = []
  domicilio: string = 'N'
  domicilioCheck: boolean = false;
  actualizando: boolean = false
  nombreCompaniaHeader: any = ""
  nombreCargoHeader: any = ""
  GestionPedidosSalon: any = GESTION_PEDIDOS_SALON;
  descripcion: string = '';
  usuariosid;
  permiteEliminarPedido: boolean = false;
  mesaCambio = []
  mesasId;
  mesasIdMesaCambio;
  companiasId;
  token: string = "";
  bluetooth: boolean = false;
  manejaImpresoPorDefecto: boolean = true;
  buscar = '';
  allItems: any;
  cargando: boolean = false;
  turno = 'Turno';
  turnos: Turnos;
  turnosId;
  turnosAsignados : any = [];
  turnosArray = [];
  pedido = 'Pedido';
  clientesSelect = [];
  usuarioSelect = [];
  usuarioId = [];
  manejaCodigoDeBarras: boolean = false;
  timerCodigoBarra;
  @ViewChild('cantidadafnprueba') cantidadafnprueba;
  creaProductoRapidoDesdeCaja: boolean = false;
  public codigoBarra:any = '';
  cantidadRealCodigoBarra:number = 0
  public formState: string = 'collapsed'
  public formStatebool:boolean= false
  listaGrupos
  @ViewChild('canvasOld') canvasElement : ElementRef;
  codigoProducto: string = '';
  nombreProducto: string = '';
  valorVenta: number = 0;
  valorImpuesto:number=0
  costo:number=0
  gruposProductosId: string = '';
  productoId: string = '';
  devolverVenta: boolean = false;
  listaClientes = [];
  valoresUsuario: string = '';
  nombreTurno: string = ""
  estado: Estados =  {
    clienteSelect: false,
    usuarioSelect: false,
    grupos: true,
    productos: false,
    pedidos: false,
    mesas: false,
    response: false
  }

  segId: string = 'products'
  estadoFormCrearCliente: boolean = false
  estadoGestionPedidos: boolean = false
  mesaSeleccionada: string = ""
  formaPagoSeleccionada: string = 'O'
  CheckPorcentajeServicio:boolean = false
  subscriptionProductosSeleccionados: Subscription;
  reconocimientoActivo: boolean = false;
  recognition: any;
  grabando: boolean = false;
  listaSeguimientoReserva = []
  @Output() cambioFiltro = new EventEmitter<string>();
  @Output() nombreGrupoReserva:any = ""
  @Output() productoFiltrado = new EventEmitter<string>();
  valorGrupoReserva: string;
  @Output() datosServiceCalendar = new EventEmitter<string>();
  nombreClienteRapido = ""
  valoresCliente = "Buscar Cliente"
  valorfecha= []
  @Output() cambiarFecha = new EventEmitter<string>();
  fechaInicio = new Date(1900, 0, 1);
  fechaInicioHora: any;
  fechaFinHora: any;
  fechaFin = new Date(1900, 0, 1);
  selectedHour: string = "";
  isTime: boolean = false;
  fechaInicialSelect: boolean = true;
  fechaInicialSelectColor: string = '#083472';
  fechaFinalSelect: boolean = false;
  constructor(
              public alertControllers: AlertController,
              public servicioMesas: MesasProvider,
              public storage: Storage,
              public servicio: CajaProvider,
              public servicioCompania: CompaniasProvider,
              public auth: AuthService,
              public platform: Platform,
              public serviciUsuario: UsuariosProvider,
              public push: PushProvider,
              public modalControllers: ModalController,
              public navCtrl: NavController,
              private iab: InAppBrowser,
              private store: Store<AppState>,
              public utilsMensajero:UtilsProvider,
              public utilsParametrosGeneralesRedux: ParametrosGeneralesRedux,
              public utilsGestionPedidosRedux: GestionPedidosRedux,
              public utilsTurnosRedux: TurnosRedux,
              public utilsClienteSelectRedux: ClienteSelectRedux,
              public utilsRedux: UtilsRedux,
              public loadingController: LoadingController,
              public renderer: Renderer,
              public providerClientes: ClientesProvider,
              public servicioProductos:ProductosProvider,
              public reservasProvider: ReservasProvider

) {

this.buscarDatosIniciales();

this.actualizar['valor'] = true;

}






async buscarDatosIniciales() {
  this.storage.get('nombreCargo').then((val) => {
    this.nombreCargoHeader = val
  });
  let buscarParametrosGeneralesStore: any = await this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesStore()
  if(buscarParametrosGeneralesStore !== null && buscarParametrosGeneralesStore.parametrosGenerales !== null) {
    this.companiasId = buscarParametrosGeneralesStore.parametrosGenerales[0][0].companiasId
    this.usuariosid = buscarParametrosGeneralesStore.parametrosGenerales[0][0].usuariosid
    this.bluetooth = buscarParametrosGeneralesStore.parametrosGenerales[0][0].bluetooth
    this.manejaImpresoPorDefecto = buscarParametrosGeneralesStore.parametrosGenerales[0][0].manejaImpresoPorDefecto
    this.manejaCodigoDeBarras = buscarParametrosGeneralesStore.parametrosGenerales[0][0].manejaCodigoDeBarras
    this.creaProductoRapidoDesdeCaja = buscarParametrosGeneralesStore.parametrosGenerales[0][0].creaProductoRapidoDesdeCaja
    this.devolverVenta = buscarParametrosGeneralesStore.parametrosGenerales[0][0].devolverVenta
    this.nombreCompaniaHeader = buscarParametrosGeneralesStore.parametrosGenerales[0][0].nombreUsuario
    let administrador = buscarParametrosGeneralesStore.parametrosGenerales[1][0].administrador
    if (administrador){
      this.permiteEliminarPedido = true
    }
  } else {
    this.servicioCompania.devolverVarios(['companiasId','usuariosId', 'nombreCargo'])
    .then((val)=>{
      if(val){
        let companiasId = val['companiasId'];
        let usuariosId = val['usuariosId'];
        let nombreUsuario = val['nombreUsuario'];
        this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesRedux(companiasId, usuariosId, nombreUsuario)
        this.buscarParametrosGeneralesBD()
      }
    })
  }

  this.cargarGruposIniciales(this.companiasId)
  this.cargarSeguimientosReserva(this.companiasId)
}

async buscarParametrosGeneralesBD() {
  let buscarParametrosGeneralesStore: any = await this.utilsParametrosGeneralesRedux.buscarParametrosGeneralesStore()

  if(buscarParametrosGeneralesStore == null && buscarParametrosGeneralesStore.parametrosGenerales == null) {
    this.utilsMensajero.mensajeMuestro('Advertencia','Debe salir y volver a ingresar para poder cargar la información, disculpe la molestía','Advertencia')
    return
  }
  if(buscarParametrosGeneralesStore.parametrosGenerales == null) {
    this.utilsMensajero.mensajeMuestro('Advertencia','Debe salir y volver a ingresar para poder cargar la información','Advertencia')
    return
  }
  this.companiasId = buscarParametrosGeneralesStore.parametrosGenerales[0][0].companiasId
  this.usuariosid = buscarParametrosGeneralesStore.parametrosGenerales[0][0].usuariosid
  this.bluetooth = buscarParametrosGeneralesStore.parametrosGenerales[0][0].bluetooth
  this.manejaImpresoPorDefecto = buscarParametrosGeneralesStore.parametrosGenerales[0][0].manejaImpresoPorDefecto
  this.manejaCodigoDeBarras = buscarParametrosGeneralesStore.parametrosGenerales[0][0].manejaCodigoDeBarras
  this.creaProductoRapidoDesdeCaja = buscarParametrosGeneralesStore.parametrosGenerales[0][0].creaProductoRapidoDesdeCaja
  this.devolverVenta = buscarParametrosGeneralesStore.parametrosGenerales[0][0].devolverVenta
  this.nombreCompaniaHeader = buscarParametrosGeneralesStore.parametrosGenerales[0][0].nombreUsuario

  let administrador = buscarParametrosGeneralesStore.parametrosGenerales[1][0].administrador
  if (administrador){
    this.permiteEliminarPedido = true
  }
}


async cargarGruposIniciales(companiasId: any) {
  this.reservasProvider.buscarReservas(companiasId).subscribe((item: any)=> {
    let res = JSON.parse(item['_body']).data
    this.listaGruposProductos = res[0]
    this.listaProductos = res[1]
    this.clienteGenericoMesa = res[2]
    this.buscarClientes(companiasId)
  })

}

async cargarSeguimientosReserva(companiasId: any,id: any = null, tipo: any = '', turno: any = 0) {
  if(id !== null) {
    this.reservasProvider.buscarSeguimientoReservas(companiasId,id, tipo, turno).subscribe((item: any)=> {
      let res = JSON.parse(item['_body']).data
      this.listaSeguimientoReserva = res[0]
    })
  } else {
    this.listaSeguimientoReserva = []
  }
}

  async buscarGruposProductosParaCaja(id: any) {
    let gestionPedidos: any = await this.utilsGestionPedidosRedux.buscarGruposProductosGestionPedidosStore()
    this.listaGruposProductos = gestionPedidos.gestionpedidos[0] == undefined ? this.listaGruposProductos : gestionPedidos.gestionpedidos[0]
    this.listaProductos = gestionPedidos.gestionpedidos[1]  == undefined ? this.listaProductos : gestionPedidos.gestionpedidos[1]
    this.clienteGenericoMesa = gestionPedidos.gestionpedidos[2] == undefined ? this.clienteGenericoMesa : gestionPedidos.gestionpedidos[2]
    this.listaClientes = gestionPedidos.gestionpedidos[2] == undefined ? this.listaClientes : gestionPedidos.gestionpedidos[2]
  }


  filtrarProductos(item) {
    this.filtroGruposActivo = true
    this.nombreFiltroGrupo = item.nombreGrupoProducto
  }


  quitarFiltroGrupos() {
    this.filtroGruposActivo = false
    this.nombreGrupoReserva = undefined
    this.nombreFiltroGrupo = ''
    let event = {
      ...this.filtrarProductos,
      ...this.nombreGrupoReserva,
      ...this.nombreFiltroGrupo
    }
    this.servicioCompania.devolverVarios(['companiasId','usuariosId', 'nombreCargo'])
    .then((val)=>{
      if(val){
        let companiasId = val['companiasId'];
        this.cargarGruposIniciales(companiasId)
        this.manejadorCambioGrupoReserva(event)
      }
    })
  }


limpiarProductoRapido(){

    this.codigoBarra =""
    this.nombreProducto = ""
    this.codigoProducto = ""
    this.valorVenta = 0
    this.costo = 0
    this.formState = 'collapsed'
    this.formStatebool = false
    this.productoId = ""
    this.cantidadRealCodigoBarra = 0
}

gestionarPedidoPorProducto(item: any, i: any) {

  let modal = this.modalControllers.create(GestionporproductoPage, {
    permiteEliminarPedido: this.permiteEliminarPedido,
    listaProductosSeleccionados:this.listaProductosSeleccionados,
    valorTotalVenta: this.valorTotalVenta,
    devolverVenta:this.devolverVenta,
    mesaCambio:this.mesaCambio,
    turnosArray: this.turnosArray,
    mesaSeleccionada:this.mesaSeleccionada,
    descripcion:this.descripcion,
    item: item,
    i: i
    }
    )
  modal.present();

  modal.onDidDismiss(data => {
    if (data) {
      let comandaId = 0
      let indexOrComandaId = false
      let descripcion = ''
      for(let i = 0;i < data.length;i++) {
        if(data[i].name === 'listaProductosSeleccionados') {
          let listaProductos = data[i].value
          comandaId =  listaProductos[0].index === undefined ? listaProductos[0].comandasId : listaProductos[0].index
          indexOrComandaId = listaProductos[0].index === undefined ? true : false
        }
        if(data[i].name === 'descripcion') {
          descripcion = data[i].value
        }

      }
      if(indexOrComandaId) {
        let index = this.listaProductosSeleccionados.findIndex((item)=> item.comandasId == comandaId)
        this.listaProductosSeleccionados[index].descripcion = descripcion
      } else {
        this.listaProductosSeleccionados[comandaId].descripcion = descripcion
      }

    }
  })
}

manejarFiltroProducto(event) {
  this.filtroGruposActivo = event.filtroGruposActivo
  this.nombreFiltroGrupo = event.nombreFiltroGrupo
  this.nombreGrupoReserva =  event.nombreFiltroGrupo
  this.cambioFiltro.emit(this.nombreFiltroGrupo);
}

manejadorCambioGrupoReserva(event: any) {
  this.filtroGruposActivo = event.filtroGruposActivo
  this.nombreFiltroGrupo = event.nombreFiltroGrupo
  this.nombreGrupoReserva =  event.nombreFiltroGrupo
  this.cambioFiltro.emit(this.nombreFiltroGrupo);
}

buscarListaCalendar(event:any) {
  let productos
  if(event.length === 2){
    productos = event.pop();
    this.nombreProducto = productos.nombre
    let companiasId = productos.companiasId
    let tipo = productos.mesasId === 0 ? 'E' : 'M';
    let productosElaboradosId = productos.productosElaboradosId

    this.reservasProvider.buscarSeguimientoReservas(companiasId,productosElaboradosId, tipo, productos.turno).subscribe((item: any)=> {
      let res = JSON.parse(item['_body']).data
      let data = res[0]
      let nuevosValores = data[0];
      nuevosValores.id = nuevosValores.idTurno
      this.fechaInicio = nuevosValores.fechaInicio
      this.fechaFin = nuevosValores.fechaFin
      this.agregarTurno(nuevosValores, nuevosValores.clienteId, productos);
    })
  } else {
    productos = event.pop();
    this.nombreProducto = productos.nombre
    if(event.length === 0 && this.clienteId.length === 0) {
      this.servicioCompania.devolverVarios(['companiasId','usuariosId', 'nombreCargo'])
      .then((val)=>{
          if(val){
            let companiasId = val['companiasId'];
            this.reservasProvider.buscarClientesPorCompaniaGeneral(companiasId)
            .subscribe( (items: any) => {
                let datadevuelta = JSON.parse(items['_body'])
                let clientesId = datadevuelta.data[0] !== undefined && datadevuelta.data[0][0] !== undefined
                &&  datadevuelta.data[0][0].clientesId !== undefined ? datadevuelta.data[0][0].clientesId : 0
                this.cargarTurno(clientesId,'',productos);
              }, (error) => {
              console.log(error);
            })
          }
        }, (error) => {
          console.log(error);
        })


    } else {
      if(this.clienteId.length === 1){
        this.clienteId[0]['value']
        let clientesId = this.clienteId[0]['value']
        this.cargarTurno(clientesId,'',productos);
      }
    }
  }

  this.listaSeguimientoReserva = event
  this.datosServiceCalendar.emit(event)
}

limpiarClienteRapido(){

  this.nombreClienteRapido = ""
  this.estadoFormCrearCliente = false

}

buscarClientes(companiasId) {
  this.servicio.buscarClientesPorCompaniaAll(companiasId)
  .subscribe((data: any)=>{
    let clientes: any = data;
    this.listaClientes = clientes;
  })
}

segmentChanged(event) {
  this.segId = event._value
  if(this.segId !== 'gestionclientes') {
    this.storage.get('companiasId').then((val) => {
      this.buscarClientes(val);
    })
  }
}

cambiarFechaClick(event: any) {
  this.valorfecha = event
  if(this.turnos !== undefined && this.turnos.turno !== undefined  ) {
    let fechaInicio:any = this.turnos.fechaInicio
    let fechaFin:any = new Date(this.turnos.fechaFin)
    let fechaSelect: boolean = this.turnos.fechaSelect;
    if(fechaSelect === true) {
      fechaInicio = new Date(event.day)
      this.turnos.fechaInicio = fechaInicio
      this.fechaInicio = fechaInicio
      this.store.dispatch(new UnsetTurnosAction());
      this.store.dispatch(new SetTurnosAction(this.turnos));

    }
    if (fechaSelect === false || new Date(event.day) > fechaInicio) {
      fechaFin = new Date(event.day);
      this.fechaFin = fechaFin;
      this.turnos.fechaFin = fechaFin
      this.store.dispatch(new UnsetTurnosAction());
      this.store.dispatch(new SetTurnosAction(this.turnos));
    }

    event.update = true
    this.cambiarFecha.emit(event)
    this.isTime = true;
  } else {
    this.utilsMensajero.mensajeMuestro('Advertencia','Debe seleccionar un producto antes de continuar','Advertencia')
    return
  }

}

cargarTurno(clienteId: any, descripcion: any, producto: any) {
  this.servicioCompania.devolverVarios(['companiasId','usuariosId', 'nombreCargo'])
  .then((val)=>{
    if(val){
        let companiasId = val['companiasId'];
        let usuariosId = val['usuariosId'];
        this.servicio.getComandasVacio(companiasId, usuariosId, clienteId, descripcion)
        .subscribe( (items: any) => {
          let valoresTurnos = JSON.parse(items['_body'])
          let valoresNuevoTurno = valoresTurnos.data[0][0]
          this.turnos = new Turnos(valoresNuevoTurno)

          this.turnosArray = [];
          this.turnosArray.push(this.turnos);
          if (this.turnos.numeroPedido === null) {
            this.turnosArray[0]['numeroPedidoMostrar'] = '';
          }
          this.nombreTurno = !this.actualizar.valor ?  "# Turno " + this.turnosArray[0].turno : 'Asignar turno'
          this.turnos.clientesId = clienteId
          this.turnos.usuariosId = usuariosId
          this.turnos.gruposReservasPorProductoId = producto.gruposReservasPorProductoId;
          this.turnos.mesasId = producto.mesasId;

          this.turnos.productosElaboradosId = producto.productosElaboradosId;
          this.turnos.nombre = producto.nombre;
          this.turnos.valorImpuesto = producto.valorImpuesto || 0;
          this.turnos.valorProducto = producto.valorProducto || 0;
          this.turnos.porcentajeImpuesto = producto.porcentajeImpuesto || 0;
          this.store.dispatch(new UnsetTurnosAction())
          this.store.dispatch(new SetTurnosAction(this.turnos));
          let listaMuestra = this.listaMuestra
          this.listaMuestra = []
          this.listaMuestra = listaMuestra
        }, (error) => {
          console.log(error);
        })
      }})
}

agregarTurno(valoresNuevoTurno:any, clienteId:any, producto: any) {
      this.turnos = new Turnos(valoresNuevoTurno)

      this.turnosArray = [];
      this.turnosArray.push(this.turnos);
      if (this.turnos.numeroPedido === null) {
        this.turnosArray[0]['numeroPedidoMostrar'] = '';
      }
      this.nombreTurno = !this.actualizar.valor ?  "# Turno " + this.turnosArray[0].turno : 'Asignar turno'
      this.turnos.clientesId = clienteId

      this.cargarCliente(this.turnos.companiasId, this.turnos.clientesId);
      this.turnos.usuariosId = 0
      this.turnos.gruposReservasPorProductoId = producto.gruposReservasPorProductoId;
      this.turnos.mesasId = producto.mesasId;

      this.turnos.productosElaboradosId = producto.productosElaboradosId;
      this.turnos.nombre = producto.nombre;
      this.turnos.valorImpuesto = producto.valorImpuesto || 0;
      this.turnos.valorProducto = producto.valorProducto || 0;
      this.turnos.porcentajeImpuesto = producto.porcentajeImpuesto || 0;
      this.store.dispatch(new UnsetTurnosAction())
      this.store.dispatch(new SetTurnosAction(this.turnos));
      let listaMuestra = this.listaMuestra
      this.listaMuestra = []
      this.listaMuestra = listaMuestra
      this.fechaInicio =  new Date(this.turnos.fechaInicio);
      this.fechaFin = new Date(this.turnos.fechaFin);
}

onEvent(event: string, item: any){
  if (event === 'onTextChange') {

   let valor = this.getItems(this.buscar);
   if(valor){
        item = valor
  }
  }
  }

  getItems(event: any): void {
    if(!this.allItems){
      let valores = this.listaProductos
      this.allItems = valores;
    }
    this.listaProductos = this.allItems.filter((item) => {
      return item.nombre.toLowerCase().indexOf(this.buscar.toLowerCase()) > -1;
    });

    }

    limpiarFechas() {
      if(this.turnos !== undefined) {
        const today = new Date();
        this.turnos.fechaInicio = today.toString()
        this.fechaInicio = today
        this.fechaFin = today
        this.store.dispatch(new UnsetTurnosAction());
        this.store.dispatch(new SetTurnosAction(this.turnos));
      }
    }

    fechaInicial() {
      this.fechaInicialSelect = true;
      this.fechaFinalSelect = false;
      this.fechaInicialSelectColor =  '#90A3D3';
      if(this.turnos !== undefined) {
        this.turnos.fechaSelect = true;
        this.store.dispatch(new UnsetTurnosAction());
        this.store.dispatch(new SetTurnosAction(this.turnos));
      }
    }

    fechaFinal() {
      this.fechaInicialSelect = false;
      this.fechaFinalSelect = true;
      this.fechaInicialSelectColor = '#08726A';
      if(this.turnos !== undefined) {
        this.turnos.fechaSelect = false;
        this.store.dispatch(new UnsetTurnosAction());
        this.store.dispatch(new SetTurnosAction(this.turnos));
      }
    }
    async enviarReserva(update: any) {
      let actualizar = update === undefined ? false: update
      let clienteSelect: any = await this.utilsClienteSelectRedux.buscarClienteSelectStore();

      let clienteId = 0
      if(clienteSelect !== undefined && clienteSelect.clienteselect !== undefined && clienteSelect.clienteselect[0]['clientesId'] !== undefined){
        clienteId = clienteSelect.clienteselect[0]['clientesId']
      }
      this.turnos.clientesId = clienteId
      if(this.turnos !== undefined &&
        this.turnos.companiasId !== null &&
        this.turnos.clientesId !== null && this.turnos.clientesId !== 0 &&
        this.turnos.usuariosId !== null &&
        this.turnos.codigo !== null &&
        this.turnos.fechaInicio !== null &&
        this.turnos.fechaFin !== null &&
        this.turnos.gruposReservasPorProductoId !== null &&
        this.turnos.mesasId !== null &&
        this.turnos.productosElaboradosId !== null){
          if(!actualizar) {
            let puedeGuardar = await this.permitirGuardarReservaYaGestionada()
            if(puedeGuardar) {
              this.reservasProvider.guardarReserva(this.turnos, actualizar)
              .subscribe( (items: any) => {
                  this.buscarDatosIniciales();
                  this.utilsMensajero.mensajeMuestro('Success','Registro guardado con exito','success')
                }, (error) => {
                console.log(error);
              })
            }
          } else {

            this.reservasProvider.guardarReserva(this.turnos, actualizar)
            .subscribe( (items: any) => {
                this.buscarDatosIniciales();
                this.utilsMensajero.mensajeMuestro('Success','Registro guardado con exito','success')
              }, (error) => {
              console.log(error);
            })
          }

        } else {
          this.utilsMensajero.mensajeMuestro('Advertencia','Faltan datos para poder guardar el registro','Advertencia')
          return
        }
    }

    async buscarTurnosStore() {
      return new Promise((resolve, reject) => {
         this.store.select('turnos').subscribe((turnos) => {
          return resolve(turnos)
         })
       });
     }

     async permitirGuardarReservaYaGestionada() {
      return new Promise(async (resolve, reject) => {
        let valoresTurno: any = await this.buscarTurnosStore();
        if(valoresTurno !== undefined &&
          valoresTurno.fechaInicio !== null &&
          valoresTurno.fechaFin !== null &&
          valoresTurno.turnos.productosElaboradosId !== null &&
          valoresTurno.turnos.companiasId !== null){
            let companiasId = valoresTurno.turnos.companiasId
            let id = valoresTurno.turnos.productosElaboradosId
            let tipo = valoresTurno.turnos.mesasId === 0 ? 'E': 'M'
            let turno = valoresTurno.turnos.turno
            this.reservasProvider.buscarSeguimientoReservasDiaAsignado(companiasId,id,tipo,turno,'S').subscribe( (items: any) => {
              let valoresTurnos = JSON.parse(items['_body'])
              let valoresNuevoTurno = valoresTurnos.data[0]

              let esValido: boolean = true; // Inicializar la variable de validación
              let turno = 0
              for (let item of valoresNuevoTurno) {
                let fechaInicio: Date = new Date(item.fechaInicio);
                let fechaFin: Date = new Date(item.fechaFin);

                // Extraer solo la parte de la fecha. (sin la hora) de day, fechaInicio y fechaFin
                let dayFecha = new Date(valoresTurno.turnos.fechaFin.getFullYear(), valoresTurno.turnos.fechaFin.getMonth(), valoresTurno.turnos.fechaFin.getDate());
                let fechaInicioFecha = new Date(fechaInicio.getFullYear(), fechaInicio.getMonth(), fechaInicio.getDate());
                let fechaFinFecha = new Date(fechaFin.getFullYear(), fechaFin.getMonth(), fechaFin.getDate());

                if (dayFecha >= fechaInicioFecha && dayFecha <= fechaFinFecha) {
                    turno = item.turno;
                    esValido = false; // Si la variable day está entre alguna de las fechas, marcar como inválido
                    break; // Salir del bucle, ya que la condición se cumplió
                }
              }

              for (let item of valoresNuevoTurno) {
                let fechaInicio: Date = new Date(item.fechaInicio);
                let fechaFin: Date = new Date(item.fechaFin);

                // Extraer solo la parte de la fecha (sin la hora) de day, fechaInicio y fechaFin
                let dayFecha = new Date(valoresTurno.turnos.fechaInicio.getFullYear(), valoresTurno.turnos.fechaInicio.getMonth(), valoresTurno.turnos.fechaInicio.getDate());
                let fechaInicioFecha = new Date(fechaInicio.getFullYear(), fechaInicio.getMonth(), fechaInicio.getDate());
                let fechaFinFecha = new Date(fechaFin.getFullYear(), fechaFin.getMonth(), fechaFin.getDate());

                if (dayFecha >= fechaInicioFecha && dayFecha <= fechaFinFecha) {
                    turno = item.turno;
                    esValido = false; // Si la variable day está entre alguna de las fechas, marcar como inválido
                    break; // Salir del bucle, ya que la condición se cumplió
                }
            }
              if(esValido) {
                resolve(true)
                return
              } else {
                resolve(false)
                this.utilsMensajero.mensajeMuestro('Warning','La fecha seleccionada ya esta reservada para el turno: ' + turno,'warning')
                return
              }
              }, (error) => {
                resolve(false)
            })

          } else {
            this.isTime=false;
            this.utilsMensajero.mensajeMuestro('Advertencia','Faltan datos para poder guardar el registro','Advertencia')
            return
          }
      });
     }

     buscarClienteSelect() {
      let modal = this.modalControllers.create(ClienteSelectPage, { data: this.listaClientes }
        )
      modal.present();

      modal.onDidDismiss(data => {
        if (data) {
          this.clienteId = []
          this.clienteId.push({value:data.value, display:data.display})
          let cliente: valueDisplay[] = [{
            value:data.value,
            display:data.display
          }]
          // const actionClienteCaja = new fromData.CargarValueDisplaySuccessActions(cliente);
          const actionClienteCaja = new fromClienteSelect.CargarValueDisplaySuccessActions(cliente);
          this.store.dispatch(actionClienteCaja);
          let clienteSelect: Clienteselect[] = [{
            clientesId: data.value,
            nombreCliente: data.display
          }]
          const actionClienteSelect = new fromClienteSelectAll.SetClienteselectAction(clienteSelect);
          this.store.dispatch(new fromClienteSelectAll.UnsetClienteselectAction())
          this.store.dispatch(actionClienteSelect);
          this.valoresCliente = 'Buscar Cliente : ' + data.display;
        }
      })
    }

cargarCliente(companiasId: any,clientesId:any) {
  this.reservasProvider.buscarClientesId( Number(clientesId),companiasId).subscribe((item: any)=> {
    let res = JSON.parse(item['_body']).data
    let result = res[0]
    let data = {
      value: this.turnos.clientesId,
      display: result[0].nombreCliente
    }
    this.clienteId = []
    this.clienteId.push({value:data.value, display:data.display})
    let cliente: valueDisplay[] = [{
      value:data.value,
      display:data.display
    }]
    const actionClienteCaja = new fromClienteSelect.CargarValueDisplaySuccessActions(cliente);
    this.store.dispatch(actionClienteCaja);
    let clienteSelect: Clienteselect[] = [{
      clientesId: data.value,
      nombreCliente: data.display
    }]
    const actionClienteSelect = new fromClienteSelectAll.SetClienteselectAction(clienteSelect);
    this.store.dispatch(new fromClienteSelectAll.UnsetClienteselectAction())
    this.store.dispatch(actionClienteSelect);
    this.valoresCliente = 'Buscar Cliente : ' + data.display;
  }, (error) => {
    console.log(error);
  })

}
cerrarSession(){
  this.auth.logout()
  this.navCtrl.setRoot('LoginPage');
}
async agregarProducto() {
  let valoresTurno: any = await this.buscarTurnosStore();
  if(valoresTurno !== undefined &&
    valoresTurno.fechaInicio !== null &&
    valoresTurno.fechaFin !== null &&
    valoresTurno.turnos.productosElaboradosId !== null &&
    valoresTurno.turnos.companiasId !== null){
      let numeromesa = valoresTurno.turnos.mesa
      let turno = valoresTurno.turnos.turno
      this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId'])
      .then((val)=>{
        if(val){
          var companiasId = val['companiasId']
          let modal = this.modalControllers.create(MeseromeseroPage, { turno:Number(turno),
            numeromesa:numeromesa,
            turnos: valoresTurno.turnos,
            companiasId: companiasId
          }, {
            cssClass: 'fullscreen-modal',
            // enableBackdropDismiss: true
          }
            )
          modal.present();

          modal.onDidDismiss(data => {
            if (data) {
              if(data !== undefined && data[0] !== undefined) {
              }
            }
          })
        }})

  }

}
}



// WEBPACK FOOTER //
// ./src/pages/reservas/reservas.ts